'use client'

import { useForm, SubmitHandler } from "react-hook-form"
import { Button, Label, Modal, TextInput } from "flowbite-react";
import { useState } from "react";

import type { LoginForm } from "@components/Common/forms";

export type LoginProps = {
    onLogin?: Function,
    onLoginError?: Function
}

import Image from 'next/image'

export function Login(props: LoginProps) {

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');

    const {
        register,
        handleSubmit,
        watch,
        formState: { errors },
    } = useForm<LoginForm>();


    const onSubmit: SubmitHandler<LoginForm> = (values) => {
        props.onLogin && props.onLogin(values.email, values.password, values.otp);
    }

    return (
        <>
            <Modal show={true} size="xl" dismissible={false}>
                <Modal.Body>
                    <div className="space-y-6">
                        <div className={'w-full align-center items-center justify-center flex'}>
                            <div className={'flex flex-1'}>
                                <h3 className="text-xl font-medium text-gray-900 dark:text-white">Log In</h3>
                            </div>
                            <div className={'flex flex-1 items-end justify-end align-end text-right'}>
                                <Image src={'/logo/circuito_white_x2.png'} width={150} height={48} alt={'Circuito Logo'} />
                            </div>
                        </div>
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <div>
                                <div className="mb-2 block">
                                    <Label htmlFor="email" value="Indirizzo e-mail" />
                                </div>
                                <TextInput
                                    color={errors.email && 'failure'}
                                    {...register('email', {
                                        required: true,
                                        pattern: /^\S+@\S+$/
                                    })}
                                    helperText={errors.email &&
                                        <>
                                            <span className="font-medium">Oops!</span> E-mail è obbligatorio.
                                        </>
                                    }
                                />
                            </div>
                            <div>
                                <div className="mb-2 block">
                                    <Label htmlFor="password" value="Password" />
                                </div>
                                <TextInput
                                    type={'password'}
                                    color={errors.password && 'failure'}
                                    {...register('password', {
                                        required: true
                                    })}
                                    helperText={errors.password &&
                                        <>
                                            <span className="font-medium">Oops!</span> Password è obbligatorio.
                                        </>
                                    }
                                />
                            </div>
                            <div>
                                <div className="mb-2 block">
                                    <Label htmlFor="otp" value="OTP Codice (se disponibile)" />
                                </div>
                                <TextInput
                                    color={errors.otp && 'failure'}
                                    {...register('otp', {
                                        required: false
                                    })}
                                />
                            </div>
                            <div className="flex justify-between my-2">
                                <div>
                                    <Button type="submit">Log In</Button>
                                </div>
                                <a href="/forgot-password" className="text-sm text-cyan-700 hover:underline dark:text-cyan-500">
                                    Password dimenticata?
                                </a>
                            </div>
                        </form>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
}